// removed by extract-text-webpack-plugin
module.exports = {"button":"_6x8LdjcbSJOnOSw2hBRTY","icon":"_1Ue-k1Mg8AXvfJvzciENNb","buttonThemeDefault":"_1pSA6FUTqh5JyNFS2zJ61y","buttonThemePrimary":"KeiRXGr01x6VoRi5k6Eoj","buttonThemeInfo":"_18KkEUej-UcDz0pRpXql8e","buttonThemeSuccess":"_2VWppBrpLJjtUqbCfJ5BWq","buttonThemeWarning":"_nRQQg8DChnGrxSUQyGuD","buttonThemeDanger":"_1fUzV4vA02Mi2yh4bRhcF"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/00-atoms/buttons/toggle-button.scss
// module id = 64
// module chunks = 0